import { getHostName } from '../utils/getHostingApp';
import { getRequestHeaders } from '../utils/getRequestHeaders';
import { IMPLEMENTATION_ENDPOINTS } from '../constants/urls';
/**
 * These constants are used in both the ConfigProvider and the ConfigContext.
 */
const host = getHostName();
export const IS_DEV = false;
export const IS_DEBUG = false;
export const RETRIEVE_URL = `${host}/genai-svc/genai/chat/retrieve-prompts`;
export const SPEECH_URL = `${host}/genai-svc/genai/speech`;
export const SPEECH_TIMEOUT = 10000;
export const TRANSCRIPTION_URL = `${host}/genai-svc/genai/audio/transcriptions`;
export const TRANSCRIPTION_TIMEOUT = 10000;
/**
 * This is the serviceConfig for each viewType.
 * New viewTypes should be added here.
 */
export const getServiceConfig = (viewType, isMobile, customerName = '', logAnalytics) => {
  const sameForAll = {
    retrieveUrl: RETRIEVE_URL,
    logAnalytics: Object.assign({
      logCustomerCarePhoneNumberClicked: () => {},
      logCustomerCarePhoneNumberDisplayed: () => {},
      logFirstMessageSubmitted: () => {}
    }, logAnalytics),
    speechFetchRequestOptions: {
      url: SPEECH_URL,
      timeout: SPEECH_TIMEOUT
    },
    transcriptionFetchRequestOptions: {
      url: TRANSCRIPTION_URL,
      timeout: TRANSCRIPTION_TIMEOUT
    }
  };
  const serviceConfig = {
    LANDING: Object.assign({
      customerName,
      debugMode: IS_DEV,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.LANDING}`,
        headers: getRequestHeaders(isMobile, {
          // 'x-product-id': viewTypeToProductIdMap[viewType.STAY].toString(),
          'x-request-from': 'homePage'
        })
      },
      isDev: IS_DEV,
      requestFrom: 'homePage',
      returnJSONResponse: true,
      showLandingChat: true,
      viewType
    }, sameForAll),
    CHECKOUT: Object.assign({
      customerName,
      debugMode: IS_DEV,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.CHECKOUT}`,
        headers: getRequestHeaders(isMobile, {
          'x-request-from': 'UC'
        })
      },
      isDev: IS_DEV,
      requestFrom: 'checkout',
      returnJSONResponse: true,
      showLandingChat: false,
      viewType
    }, sameForAll),
    DRIVE: Object.assign({
      customerName,
      debugMode: IS_DEV,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.DRIVE}`,
        headers: getRequestHeaders(isMobile, {
          'x-request-from': 'rcListingPage'
        })
      },
      isDev: IS_DEV,
      requestFrom: 'rcListings',
      returnJSONResponse: true,
      showLandingChat: false,
      viewType
    }, sameForAll),
    FLY: Object.assign({
      customerName,
      debugMode: IS_DEV,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.FLY}`,
        headers: getRequestHeaders(isMobile, {
          'x-request-from': 'flightListings'
        })
      },
      isDev: IS_DEV,
      requestFrom: 'flightListings',
      returnJSONResponse: true,
      showLandingChat: false,
      viewType
    }, sameForAll),
    ITINERARY: Object.assign({
      customerName,
      debugMode: IS_DEV,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.ITINERARY}`,
        headers: getRequestHeaders(isMobile, {
          'x-request-from': 'travel-itinerary'
        })
      },
      isDev: IS_DEV,
      requestFrom: 'travel-itinerary',
      showLandingChat: false,
      viewType
    }, sameForAll),
    PACKAGE: Object.assign({
      customerName,
      debugMode: IS_DEV,
      isDev: IS_DEV,
      viewType,
      showLandingChat: false,
      requestFrom: '',
      returnJSONResponse: true,
      fetchRequestOptions: {}
    }, sameForAll),
    PORTAL: Object.assign({
      customerName,
      debugMode: IS_DEV,
      isDev: IS_DEV,
      viewType,
      showLandingChat: false,
      returnJSONResponse: true,
      requestFrom: 'pennyPortalPage',
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.PORTAL}`,
        headers: {
          'x-request-from': 'pennyPortalPage',
          'x-model-version': '4'
        }
      }
    }, sameForAll),
    STAYDETAILS: Object.assign({
      customerName,
      debugMode: IS_DEV,
      isDev: IS_DEV,
      viewType,
      showLandingChat: false,
      requestFrom: 'hotelDetailPage',
      returnJSONResponse: true,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.STAYDETAILS}`,
        headers: getRequestHeaders(isMobile, {
          'x-request-from': 'hotelDetailPage'
        })
      }
    }, sameForAll),
    STAYLISTINGS: Object.assign({
      customerName,
      debugMode: IS_DEV,
      isDev: IS_DEV,
      viewType,
      showLandingChat: false,
      requestFrom: 'hotelListingPage',
      returnJSONResponse: true,
      fetchRequestOptions: {
        url: `${host}${IMPLEMENTATION_ENDPOINTS.STAYLISTINGS}`,
        headers: getRequestHeaders(isMobile, {
          'x-request-from': 'hotelListingPage'
        })
      }
    }, sameForAll)
  };
  // Ensure viewType has a valid service config
  const config = serviceConfig[viewType];
  if (!config) {
    throw new Error(`No service configuration found for viewType: ${viewType}. ` + 'Add configuration to serviceConfig object in /react-components/penny-chat-bot/src/config/serviceConfig.ts. ');
  }
  return config;
};